import { render, staticRenderFns } from "./form-wheel-tyre.vue?vue&type=template&id=800d2424"
import script from "./form-wheel-tyre.vue?vue&type=script&lang=js"
export * from "./form-wheel-tyre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports